import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GlobalRef } from "../../shared/globals/global-ref";
import { IActionResponse } from "../../shared/interfaces/models/iaction-response.model";
import { IEntityValidation } from "../../shared/interfaces/models/ientity-validation.model";
import { AppSettings } from "../../shared/models/appsettings";
import { DictionaryBaseService } from "../../shared/services/dictionary-base.service";
import { UserContextService } from "../../shared/services/user-context.service";
import { IIdeaLike } from "./idea-like.model";
import { IIdea } from "./idea.model";
import { IGroupedStat } from "./igrouped-stat.model";

@Injectable({
  providedIn: "root",
})
export class IdeasService extends DictionaryBaseService<IIdea> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += "Ideas/";
  }

  saveWithFiles(
    model: IIdea,
    filesForUpload: File[]
  ): Observable<IIdea> {
    const formData = new FormData();
    if (filesForUpload) {
      for (var i = 0; i < filesForUpload.length; i++) {
        formData.append("files", filesForUpload[i]);
      }
    }
    formData.append("model", JSON.stringify(model));
    return this.http
      .post<IIdea>(
        this.svcUrl + "savewithattachments",
        formData
      )
      .pipe(catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getCODecisionReadyIdeas(): Observable<IIdea[]> {
    return this.http.get<IIdea[]>(
      this.svcUrl +
        "GetCOECDecisionReadyIdeas?businessFunctionId=" +
        this.userContextSvc.currentUser.SelectedBF?.Id
    );
  }

  getECDecisionReadyIdeas(): Observable<IIdea[]> {
    return this.http.get<IIdea[]>(
      this.svcUrl +
        "GetECDecisionReadyIdeas?businessFunctionId=" +
        this.userContextSvc.currentUser.SelectedBF?.Id +
        "&orgunitId=" +
        this.userContextSvc.currentUser.OrgUnit.Id
    );
  }

  addLike(ideaId: number): Observable<IActionResponse<number>> {
    let model: IIdeaLike = this.createLike(
      ideaId,
      AppSettings.idealike.type.likeId
    );
    return this.setLike(model);
  }

  addDislike(ideaId: number): Observable<IActionResponse<number>> {
    let model: IIdeaLike = this.createLike(
      ideaId,
      AppSettings.idealike.type.dislikeId
    );
    return this.setLike(model);
  }

  createLike(ideaId: number, typeId: number): IIdeaLike {
    let model: IIdeaLike = {
      Id: 0,
      IdeaId: ideaId,
      TypeId: typeId,
      UserId: this.userContextSvc.currentUser.Id,
    };
    return model;
  }

  setLike(model: IIdeaLike): Observable<IActionResponse<number>> {
    return this.http.post<IActionResponse<number>>(
      this.svcUrl + "SetLike",
      model
    );
  }

  removeLike(model: IIdeaLike): Observable<IActionResponse<number>> {
    return this.http.post<IActionResponse<number>>(
      this.svcUrl + "removelike",
      model
    );
  }

  isAssigneeIdea(user_id: number, idea_id: number): Observable<boolean> {
    return this.http.get<boolean>(
      this.svcUrl + "IsAssigneeIdea?user_id=" + user_id + "&idea_id=" + idea_id
    );
  }

  validate(model: IIdea): IEntityValidation {
    let res: IEntityValidation = { Valid: true };
    let valid = !(!model.AuthorName);
    if (!valid) {
      res.Valid = false;
      res.Message = "Не заполнены обязательные поля";
      return res;
    }
    return res;
  }

  findCurrentUserLike(likes: IIdeaLike[]): IIdeaLike {
    if (!likes || likes.length < 1) {
      return null;
    }
    let currentLike = likes.find(
      (x) => x.UserId == this.userContextSvc.currentUser.Id
    );
    return currentLike;
  }

  getAuthorIdeasGroupedByStatus(authorId: number): Observable<IGroupedStat[]> {
    return this.http.get<IGroupedStat[]>(
      this.svcUrl + "GetAuthorIdeasGroupedByStatus?authorId=" + authorId
    );
  }

  getAuthorIdeasGroupedByBF(authorId: number): Observable<IGroupedStat[]> {
    return this.http.get<IGroupedStat[]>(
      this.svcUrl + "GetAuthorIdeasGroupedByBF?authorId=" + authorId
    );
  }

  getWorkflowTypeTitle(typeId: number): string {
    switch (typeId) {
      case AppSettings.workflow.type.validationId:
        return AppSettings.workflow.type.validationTitle;
      case AppSettings.workflow.type.douExpertId:
        return AppSettings.workflow.type.douExpertTitle;
      case AppSettings.workflow.type.ouExpertCouncilId:
        return AppSettings.workflow.type.ouExpertCouncilTitle;
      case AppSettings.workflow.type.ouECDecisionId:
        return AppSettings.workflow.type.ouECDecisionTitle;
      case AppSettings.workflow.type.ouRealizationId:
        return AppSettings.workflow.type.ouRealizationTitle;
      case AppSettings.workflow.type.coECDecisionId:
        return AppSettings.workflow.type.coECDecisionTitle;
      case AppSettings.workflow.type.coRealizationId:
        return AppSettings.workflow.type.coRealizationTitle;
      case AppSettings.workflow.type.directionExpertApprovalId:
        return AppSettings.workflow.type.directionExpertApprovalTitle;
      case AppSettings.workflow.type.directionExpertCOApprovalId:
        return AppSettings.workflow.type.directionExpertCOApprovalTitle;
      default:
        return "(не определено)";
    }
  }

  presentation(id: number) {
    const url = this.svcUrl + "Presentation?id=" + id;
    window.open(url, "_blank");
  }

  getByIdWithViewIncrement(ideaId: number): Observable<IIdea> {
    return this.getById(ideaId);
  }
}
